module.exports = __webpack_public_path__ + "img/kabaddi.0f69472.png";